module.exports = __webpack_public_path__ + "static/media/Burak.6aa7f6aa.jpg";